<template>
  <ViewTransition>
    <div
      id="gtm-history"
      class="History"
      v-window-resize="updatedisplayDeskTl"
      v-hammer:swipe.horizontal="handleSwipe"
    >
      <HistoryHeader>
        <CarouselPagination :active="activeRange + 1" :len="model.length" />
      </HistoryHeader>
      <div class="History-range">
        <RangeSlide
          v-for="(item, index) in model"
          v-show="index === activeRange"
          :key="index"
          :index="index"
          :range="item"
          :anim-direction="animDirection"
        />
      </div>
      <TlDesk
        v-if="displayDeskTl"
        :activeRange="activeRange"
        :activePin="activePin"
        :model="model"
        @range-click="updateActiveRange"
        @pin-click="updateActivePin"
      />
      <HistoryFooter :range="nextRange" @click.native="upAndNext" />
    </div>
  </ViewTransition>
</template>

<script>
import gsap from "gsap";
import CarouselPagination from "@/components/CarouselPagination";
import HistoryHeader from "@/components/HistoryHeader";
import HistoryFooter from "@/components/HistoryFooter";
import model from "@/data/history.json";
import RangeSlide from "@/components/RangeSlide";
import TlDesk from "@/components/TlDesk";
import ViewTransition from "@/transitions/ViewTransition";
import TagFunctions from "@/assets/tagFunctions.js";

export default {
  components: {
    CarouselPagination,
    HistoryHeader,
    HistoryFooter,
    RangeSlide,
    TlDesk,
    ViewTransition,
  },
  data: () => ({
    model,
    activeRange: 0,
    activePin: 0,
    animDirection: undefined,
    displayDeskTl: false,
  }),
  mounted() {
    this.updatedisplayDeskTl();
    TagFunctions.evPagePush('Historia')
  },
  computed: {
    nextRange() {
      const { activeRange, model } = this;
      return activeRange == model.length - 1
        ? model[0]
        : model[activeRange + 1];
    },
  },
  methods: {
    handleSwipe(ev) {
      if (ev.type == "swipeleft") this.upAndNext("left");
      else this.upAndBack("right");
    },
    back(dir = "left") {
      const { activeRange, model } = this;
      this.animDirection = dir;
      this.activeRange = activeRange == 0 ? model.length - 1 : activeRange - 1;
    },
    next(dir = "right") {
      const { activeRange, model } = this;
      this.animDirection = dir;
      this.activeRange = activeRange == model.length - 1 ? 0 : activeRange + 1;
    },
    goto(index) {
      const { activeRange } = this;
      if (index !== activeRange) {
        this.animDirection = index > activeRange ? "left" : "right";
        this.activeRange = index;
      }
    },
    up() {
      gsap.to(window, { duration: 0.2, scrollTo: 0 });
    },
    upAndBack() {
      this.up();
      this.back("right");
    },
    upAndNext() {
      this.up();
      this.next("left");
    },
    updateActiveRange(index) {
      this.activePin = 0;
      this.goto(index);
    },
    updateActivePin(index) {
      this.activePin = index;
    },
    updatedisplayDeskTl() {
      this.displayDeskTl = window.innerWidth >= 1100;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './History.styl';
</style>
